import { BaseDto } from "../common/baseDto";
import { formatDate } from "../../utils/string/stringUtil";

export interface ProductOrderDto extends BaseDto {

    productOrderNo: string;         // 작업지시no
    compCd: string;                 // 사업장
	compNm: string;                 // 사업장명
    orderDt: string | undefined;    // 일자
    orderType: string;              // 지시구분/ORDTYPE.
    workplaceCd: string;            // 공정코드/mst_workplace.
    workplaceNm: string;            // 공정명
    jobTeam: string;                // 작업조/JOBTEAM.
    workProcess: string;            // 공정유형/WORKPROCESS.
    itemCd: string;                 // 품목코드/ITEMCD.MSTITEM
	itemNm: string;                 // 품명
	itemSpec: string;               // 규격
	itemUnit: string;               // 단위
    orderQty: number;               // 지시수량
    orderEmp: string;               // 사원코드/EMPNO.MSTEMP
	orderEmpNm: string;             // 사원명
    productPlanNo: string;          // 계획번호/.
	resultQty: number;              // 생산실적량
	basOrderType: string;			// 작업지시(생산실적) 주문유형	
	basOrderNo: string;				// 작업지시(생산실적) 주문번호
	basOrderItemNo: string;			// 작업지시(생산실적) 주문항목번호
	closeTag: string;               // 마감여부 Y/N
    remark: string;                 // 비고

	inserted: boolean;
	isModified: boolean;
}

export const defaultProductOrderDto: ProductOrderDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	productOrderNo: '',
	compCd: '',
	compNm: '',
	orderDt: formatDate(new Date()),
	orderType: '',
	workplaceCd: '',
	workplaceNm: '',
	jobTeam: '',
	workProcess: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	orderQty: 0,
	orderEmp: '',
	orderEmpNm: '',
	productPlanNo: '',
	resultQty: 0,
	basOrderType: '',
	basOrderNo: '',
	basOrderItemNo: '',
	closeTag: "N",
	remark: '',

	inserted: false,
	isModified: false
}










